import { AdditionalOption } from '@shared/api/giftItemInfo/giftItemInfo.interface';
import { GiftSelectedOption } from '@shared/api/giftOrder/giftOrder.interface';
import { Image } from '@shared/api/media/media.interface';

/** 주문 스냅샷(GiftSelectedOption[]) → 선택 맵 (optionName -> 슬롯별 choiceName) */
export const selectedOptionsToMap = (
  selectedOptions?: GiftSelectedOption[],
): Record<string, string[]> => {
  const map: Record<string, string[]> = {};
  for (const o of selectedOptions ?? []) {
    const arr = map[o.optionName] ?? (map[o.optionName] = []);
    arr[o.slotIndex ?? 0] = o.choiceName;
  }
  return map;
};

/**
 * 선택 맵 + 옵션 정의 → 주문 스냅샷(GiftSelectedOption[]).
 * selectionCount만큼 슬롯을 순회하고, selectionCount>1이면 slotIndex를 포함한다.
 */
export const buildSelectedOptions = (
  options: AdditionalOption<Image>[],
  map: Record<string, string[]>,
): GiftSelectedOption[] => {
  const result: GiftSelectedOption[] = [];
  for (const opt of options) {
    const count = Math.max(1, opt.selectionCount ?? 1);
    const slots = map[opt.name] ?? [];
    for (let s = 0; s < count; s++) {
      const choiceName = slots[s];
      if (!choiceName) continue;
      const choice = opt.choices?.find((c) => c.name === choiceName);
      if (!choice) continue;
      result.push({
        optionName: opt.name,
        choiceName: choice.name,
        priceDelta: choice.priceDelta || 0,
        ...(count > 1 && { slotIndex: s }),
      });
    }
  }
  return result;
};

/** 선택옵션 시그니처 (itemId와 함께 장바구니 라인 식별용). 슬롯 번호까지 포함 */
export const optionSignature = (
  opts?: { optionName: string; slotIndex?: number; choiceName: string }[],
): string =>
  (opts ?? [])
    .map((o) => `${o.optionName}#${o.slotIndex ?? 0}:${o.choiceName}`)
    .join('|');
